import React, { useEffect, useState } from "react";
import { Button, Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import {
  getNotificationStatus,
  requestNotificationPermission,
} from "../../services/browserNotifications";

const NotificationPermissionBanner = () => {
  const [status, setStatus] = useState(getNotificationStatus);

  useEffect(() => {
    const updateStatus = () => setStatus(getNotificationStatus());
    window.addEventListener("focus", updateStatus);
    document.addEventListener("visibilitychange", updateStatus);
    return () => {
      window.removeEventListener("focus", updateStatus);
      document.removeEventListener("visibilitychange", updateStatus);
    };
  }, []);

  if (status === "granted" || status === "unsupported") return null;
  const blocked = status === "denied";
  const handleEnable = async () => setStatus(await requestNotificationPermission());

  return (
    <Snackbar open anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
      <Alert
        severity={blocked ? "warning" : "info"}
        action={blocked ? null : (
          <Button color="inherit" size="small" onClick={handleEnable}>
            Ativar notificações
          </Button>
        )}
      >
        <strong>🔔 Ativar notificações</strong><br />
        {blocked
          ? "A permissão está bloqueada. Libere as notificações nas configurações do navegador ou celular."
          : "Ative as notificações para receber avisos de novas mensagens e atendimentos."}
      </Alert>
    </Snackbar>
  );
};

export default NotificationPermissionBanner;
